import { render, staticRenderFns } from "./ReviewSection.vue?vue&type=template&id=a7984c34&"
import script from "./ReviewSection.vue?vue&type=script&lang=js&"
export * from "./ReviewSection.vue?vue&type=script&lang=js&"
import style0 from "./ReviewSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports